// Autenticación por token (Bearer) como complemento a la cookie de sesión.
// Necesario cuando el frontend y la API viven en dominios distintos
// (p. ej. dev-rd.cloud → api.redmobility.net): la cookie SameSite no viaja
// cross-site, pero el header Authorization sí. El backend acepta ambos.
import axios from 'axios';

const KEY = 'rm_session_token';
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export const getToken = () => {
  try { return localStorage.getItem(KEY); } catch { return null; }
};
export const setToken = (t) => {
  try { t ? localStorage.setItem(KEY, t) : localStorage.removeItem(KEY); } catch {}
};
export const clearToken = () => setToken(null);

// Instala los interceptores globales una sola vez (llamar en index.js).
export function installAuthInterceptors() {
  // axios: añade el header en cada request
  axios.interceptors.request.use((config) => {
    const token = getToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  // fetch: envuelve window.fetch para añadir el header a las llamadas a la API
  if (typeof window !== 'undefined' && window.fetch) {
    const original = window.fetch.bind(window);
    window.fetch = (input, init = {}) => {
      const token = getToken();
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const isApiCall = BACKEND_URL && url.startsWith(BACKEND_URL);
      if (token && isApiCall) {
        const headers = new Headers(init.headers || (typeof input !== 'string' ? input.headers : undefined) || {});
        if (!headers.has('Authorization')) headers.set('Authorization', `Bearer ${token}`);
        init = { ...init, headers };
      }
      return original(input, init);
    };
  }
}
